import React from 'react';
import PropTypes from 'prop-types';
import { withFormikField } from 'utils/formik';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { Button } from '@ontruck/orc';

import { StyledContainer, StyledChild } from './styled';

import {
  NumberOfItemsInput,
  WeightInput,
  LoadTypeSelector,
} from 'modules/shipper-order/Form/fields';
import { NUMBER_OF_ITEMS_FIELD, TOTAL_WEIGHT_FIELD } from 'modules/shipper-order/Form/constants';

const LoadSection = ({ field, showClear, onDelete, form }) => {
  return (
    <StyledContainer alignItems="center" flexWrap="wrap">
      <StyledChild>
        <NumberOfItemsInput name={[field.name, NUMBER_OF_ITEMS_FIELD]} />
      </StyledChild>
      <StyledChild>
        <LoadTypeSelector name={field.name} />
      </StyledChild>
      <StyledChild>
        <WeightInput name={[field.name, TOTAL_WEIGHT_FIELD]} />
      </StyledChild>
      {showClear && (
        <StyledChild mRight="N">
          <Button skin="secondary" nude onClick={onDelete}>
            <TrashIcon />
          </Button>
        </StyledChild>
      )}
    </StyledContainer>
  );
};

LoadSection.propTypes = {
  field: PropTypes.object,
  showClear: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default withFormikField(LoadSection);
